import { render, staticRenderFns } from "./QuotationResourceForm.vue?vue&type=template&id=47976102&scoped=true"
import script from "./QuotationResourceForm.vue?vue&type=script&lang=js"
export * from "./QuotationResourceForm.vue?vue&type=script&lang=js"
import style0 from "./QuotationResourceForm.vue?vue&type=style&index=0&id=47976102&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47976102",
  null
  
)

export default component.exports